// Headshot assets for the booking-step account managers, keyed by AM key.
// Sourced from the 2026-05-07 onboarding prototype; swap for final art later.
// `team` (GRW-330, round-robin) is a pool, not a person — it has no headshot,
// so the top tier renders neutral team framing (null → no <img>).
import { AmKey } from '../../view-model/amProfiles';
import brookeHeadshot from './assets/brooke.png';
import klaberaHeadshot from './assets/klabera.png';

export const AM_HEADSHOTS: Record<AmKey, string | null> = {
  brooke: brookeHeadshot,
  klabera: klaberaHeadshot,
  team: null,
};
